var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectionStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7497 16.7916V25.8333H5.66634V7.74998H12.1505C12.2151 6.8329 12.4347 5.96748 12.7705 5.16665H5.66634C4.24551 5.16665 3.08301 6.32915 3.08301 7.74998V25.8333C3.08301 27.2541 4.24551 28.4166 5.66634 28.4166H23.7497C25.1705 28.4166 26.333 27.2541 26.333 25.8333V19.375L23.7497 16.7916ZM21.8122 23.25H7.60384L11.1559 18.6904L13.6876 21.7387L17.2397 17.1662L21.8122 23.25ZM25.4288 11.4829C25.9972 10.5787 26.333 9.53248 26.333 8.39581C26.333 5.17956 23.7368 2.58331 20.5205 2.58331C17.3043 2.58331 14.708 5.17956 14.708 8.39581C14.708 11.6121 17.3043 14.2083 20.5076 14.2083C21.6443 14.2083 22.7034 13.8725 23.5947 13.3041L27.6247 17.3341L29.4588 15.5L25.4288 11.4829ZM20.5205 11.625C19.6641 11.625 18.8427 11.2848 18.2371 10.6792C17.6316 10.0736 17.2913 9.25224 17.2913 8.39581C17.2913 7.53938 17.6316 6.71803 18.2371 6.11245C18.8427 5.50686 19.6641 5.16665 20.5205 5.16665C21.3769 5.16665 22.1983 5.50686 22.8039 6.11245C23.4095 6.71803 23.7497 7.53938 23.7497 8.39581C23.7497 9.25224 23.4095 10.0736 22.8039 10.6792C22.1983 11.2848 21.3769 11.625 20.5205 11.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionStarted);
export default __webpack_public_path__ + "static/media/inspection-started.fe024871341015a4c74704a6c24e927e.svg";
export { ForwardRef as ReactComponent };